import { useWorkspaceBilling } from "./use-workspace-billing";
import { getWorkspaceUsageRate } from "@/lib/billing-config";

export const useWallet = () => {
  // Use workspace billing for credits/balance
  const { data: workspaceBilling, ...rest } = useWorkspaceBilling();

  const walletBalance = workspaceBilling?.wallet_balance_credits || 0;
  const freeMinutes = workspaceBilling?.free_minutes_remaining || 0;
  const usageRatePerMinute = getWorkspaceUsageRate(workspaceBilling);
  const freeMinutesValue = freeMinutes * usageRatePerMinute;
  const totalAvailable = walletBalance + freeMinutesValue;

  return {
    ...rest,
    walletBalance,
    freeMinutes,
    freeMinutesValue,
    totalAvailable,
    usageRatePerMinute,
    profile: workspaceBilling,
  };
};
